import PublicDomainListsDashboard from "./PublicDomainListsDashboard";

export default PublicDomainListsDashboard;
